import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scroll", "tooltip"]

  connect() {
    // Auto-scroll to the rightmost (most recent) week
    // Use rAF to ensure SVG layout is complete before scrolling
    if (this.hasScrollTarget) {
      requestAnimationFrame(() => {
        this.scrollTarget.scrollLeft = this.scrollTarget.scrollWidth
      })
    }

    this.cells = this.element.querySelectorAll("rect.heatmap-cell[data-tooltip]")
    this.boundShow = this.showTooltip.bind(this)
    this.boundHide = this.hideTooltip.bind(this)

    this.cells.forEach(cell => {
      cell.addEventListener("mouseenter", this.boundShow)
      cell.addEventListener("mouseleave", this.boundHide)
      cell.addEventListener("focus", this.boundShow)
      cell.addEventListener("blur", this.boundHide)
    })
  }

  disconnect() {
    this.cells?.forEach(cell => {
      cell.removeEventListener("mouseenter", this.boundShow)
      cell.removeEventListener("mouseleave", this.boundHide)
      cell.removeEventListener("focus", this.boundShow)
      cell.removeEventListener("blur", this.boundHide)
    })
  }

  showTooltip(event) {
    if (!this.hasTooltipTarget) return

    const cell = event.currentTarget
    const text = cell.getAttribute("data-tooltip")
    if (!text) return

    this.tooltipTarget.textContent = text
    this.tooltipTarget.classList.add("is-visible")

    const containerRect = this.element.getBoundingClientRect()
    const cellRect = cell.getBoundingClientRect()
    const tooltipRect = this.tooltipTarget.getBoundingClientRect()

    let left = cellRect.left - containerRect.left + (cellRect.width / 2) - (tooltipRect.width / 2)
    const top = cellRect.top - containerRect.top - tooltipRect.height - 6

    // Clamp within container
    left = Math.max(0, Math.min(left, containerRect.width - tooltipRect.width))

    this.tooltipTarget.style.left = `${left}px`
    this.tooltipTarget.style.top = `${top}px`
  }

  hideTooltip() {
    if (!this.hasTooltipTarget) return
    this.tooltipTarget.classList.remove("is-visible")
  }
}
